import { combineReducers as e } from "/codebuild/output/src3156664917/src/frontend/ui-redux/node_modules/redux/es/redux.js";
import { userReducer as r } from "./user/reducers.js";
import { modalReducer as o } from "./modal/reducers.js";
import { tableReducer as m } from "./table/reducers.js";
import { preferenceReducer as p } from "./preference/reducers.js";
import "/codebuild/output/src3156664917/src/node_modules/lodash/lodash.js";
import { propChangeReducer as c } from "./propChange/reducers.js";
const n = e({
  user: r,
  modal: o,
  table: m,
  preferenceSlice: p,
  propChange: c
});
export {
  n as rootReducer
};
//# sourceMappingURL=rootReducer.js.map
